import {useContext} from "react";
import {AppContext} from "../../components/shared/context";
import {atualizaUserRole} from "../../services/usuario/UsuarioService";
import CheckMarkSVG from '../../utils/svgs/checkmark';
import MenuItem from '@material-ui/core/MenuItem';

const Roles = (props) => {

  const { roles, keycloak, role } = useContext(AppContext);

  const { subject } = keycloak

  const estadosMap = {
    'AM': 'Amazonas',
    'AL': 'Alagoas',
    'AC': 'Acre',
    'AP': 'Amapá',
    'BA': 'Bahia',
    'PA': 'Pará',
    'MT': 'Mato Grosso',
    'MG': 'Minas Gerais',
    'MS': 'Mato Grosso do Sul',
    'GO': 'Goiás',
    'MA': 'Maranhão',
    'RS': 'Rio Grande do Sul',
    'TO': 'Tocantins',
    'PI': 'Piauí',
    'SP': 'São Paulo',
    'RO': 'Rondônia',
    'RR': 'Roraima',
    'PR': 'Paraná',
    'CE': 'Ceará',
    'PE': 'Pernambuco',
    'SC': 'Santa Catarina',
    'PB': 'Paraíba',
    'RN': 'Rio Grande do Norte',
    'ES': 'Espírito Santo',
    'RJ': 'Rio de Janeiro',
    'SE': 'Sergipe',
    'DF': 'Distrito Federal',
    'NA': 'Nacional'
  }

  const rolesMap = {
    'ROLE_CONSELHEIRO': 'Conselheiro',
    'ROLE_EQUIPE_TECNICA': 'Equipe Técnica',
    'ROLE_INTERLOCUTOR': 'Interlocutor'
  }

  const renderRow = (row) => {
    if (props.header) {
      return (
        <MenuItem 
        style={{
          display:'flex',
          justifyContent: role === row ? 'space-between' : 'flex-end',
          alignItems:'center'
        }} 
        key={row}
        onClick={() => atualizarRole(subject, row)}>
          {role === row ? <CheckMarkSVG /> : ''}{getNomePefil(row)}
        </MenuItem>
      )
    }
    return <li
      tabIndex={1}
      style={{ cursor: 'pointer' }}
      key={row}
      onClick={() => atualizarRole(subject, row)}>
      {getNomePefil(row)}
    </li>;
  }

  function getNomePefil(row) {

    let keyEstado;
    let perfil;

    if(row.slice(row.length - 3, row.length - 2) != '_' && row.slice(0, 5) == 'ROLE_'){
      keyEstado = 'NA'
      perfil = rolesMap[row];
    }else{
      keyEstado = row.slice(row.length - 2, row.length);
      perfil = rolesMap[row.slice(0, row.length - 3)];
    }
    let estado = keyEstado == 'NA' ? estadosMap[keyEstado] : keyEstado;
    return perfil + ' - ' + estado;
  }

  const atualizarRole = async (subject, role) => {
    await atualizaUserRole(subject, { roleSelecionada: role });
    window.location.reload();
  }

  if (props.header) {
    return (
      <>
        {roles.map(renderRow)}
      </>
    )
  }

  return (
    <ul style={{ listStyleType: 'none' }}>
      {roles.map(renderRow)}
    </ul>
  );

}

export default Roles;
